import { render, staticRenderFns } from "./bulk-import-consent.vue?vue&type=template&id=758e5d1a&scoped=true&"
import script from "./bulk-import-consent.vue?vue&type=script&lang=js&"
export * from "./bulk-import-consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758e5d1a",
  null
  
)

export default component.exports